// extracted by mini-css-extract-plugin
module.exports = {"lightCheckbox":"LrvCheckbox_lightCheckbox__3OIkJ","darkCheckbox":"LrvCheckbox_darkCheckbox__uMKqb"};